import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { db, auth } from '../firebase';

export const useEmailVerification = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        // 사용자가 로그인되어 있지 않은 경우
        if (!user) {
          navigate('/signin');
          return;
        }

        // 사용자 프로필 확인
        const userProfileRef = doc(db, 'user_profiles', user.uid);
        const userProfileSnap = await getDoc(userProfileRef);

        if (userProfileSnap.exists()) {
          const userData = userProfileSnap.data();
          // 이메일 인증을 거치지 않은 사용자 체크
          if (userData.userLevel === 10 || userData.role === null) {
            navigate('/email-verification');
            return;
          }
        }
      } catch (error) {
        console.error('이메일 인증 상태 확인 중 오류:', error);
      } finally {
        setLoading(false);
      }
    });

    // 클린업 함수
    return () => unsubscribe();
  }, [navigate]);

  return { loading };
}; 